
<mat-label class="subHeading">Rule ID<span *ngIf="required" class="star">*</span></mat-label>
<input type="text" formControlName="rule_id" class="rule mt-2"/>

